// Keep native cart markup available while controlling its visibility.
(() => {
  const setup = () => {
    const link = document.getElementById('cart-icon-bubble');
    if (!link || link.dataset.retailVisibilityBound === 'true') return;
    link.dataset.retailVisibilityBound = 'true';
    const sync = () => {
      link.hidden = link.dataset.retailCartContext !== 'true' && !link.querySelector('.cart-count-bubble');
    };
    new MutationObserver(sync).observe(link, { childList: true, subtree: true });
    sync();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
  document.addEventListener('shopify:section:load', setup);
  window.addEventListener('pageshow', setup);
})();
